import ufeApi from 'services/api/ufeApi';
import Empty from 'constants/empty';

const path = '/gway/v1/p13n/puwlo/replen';

function normalizeReplenRow(row) {
    if (!row) {
        return null;
    }

    const p13n = row.p13n;

    if (!p13n) {
        return null;
    }

    return {
        context: p13n.context,
        servedSkuNumber: p13n.servedSkuNumber || '',
        productId: p13n.productId || '',
        replenCategory: p13n.replen_category || p13n.replenCategory || '',
        skuImageUrl: p13n.skuImageUrl || '',
        caching: p13n.caching,
        isControl: p13n.isControl,
        isDefault: p13n.isDefault,
        isAbTest: p13n.isAbTest,
        isReplenEnabled: p13n.isReplenEnabled,
        abTestId: p13n.abTestId || '',
        abTestEndDate: p13n.abTestEndDate ?? p13n.endDate ?? null
    };
}

function getP13nReplenData({
    channel, country, language, atgId, contextId
}) {
    const locale = `${language}-${country}`;
    const queryParams = `/${encodeURIComponent(contextId)}?atg_id=${encodeURIComponent(atgId)}&channel=${encodeURIComponent(channel)}&locale=${encodeURIComponent(locale)}`;
    const url = `${path}${queryParams}`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(({ data = Empty.Array, errorCode }) => {
        if (errorCode) {
            return Promise.reject(data);
        }

        const firstRow = Array.isArray(data) ? data[0] : data;

        return normalizeReplenRow(firstRow);
    });
}

export default getP13nReplenData;
